import "../../core/ui/constants.js";
import { getMediaInputActionValue } from "../media-action-value.js";
import { isUndefined } from "@videojs/utils/predicate";
//#region src/dom/gesture/action-value.ts
/** Resolves the effective value for a gesture action from its explicit value and region. */
function getGestureActionValue(action, region, value) {
	if (action === "seekStep" && isUndefined(value) && region === "left") return -10;
	return getMediaInputActionValue(action, void 0, value);
}
//#endregion
export { getGestureActionValue };

//# sourceMappingURL=action-value.js.map